// extracted by mini-css-extract-plugin
export default {"message":"message_message__bAlOt","message1":"message_message1__qadVY","message2":"message_message2__nnssf","message3":"message_message3__AELet","message4":"message_message4__Vmbkf"};